import { render, staticRenderFns } from "./LoaderDots.vue?vue&type=template&id=a6d7134c&scoped=true"
import script from "./LoaderDots.vue?vue&type=script&lang=js"
export * from "./LoaderDots.vue?vue&type=script&lang=js"
import style0 from "./LoaderDots.vue?vue&type=style&index=0&id=a6d7134c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d7134c",
  null
  
)

export default component.exports